import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./Hamburger.module.scss";

function Hamburger({ isOpen, onClick }) {
  return (
    <div
      className={styles.container}
      onClick={onClick}
      onKeyPress={onClick}
      role="button"
      tabIndex="0"
      aria-label="nav"
    >
      <div
        className={classnames(
          styles.line,
          isOpen ? styles.line_top_open : styles.line_top,
        )}
      />
      <div
        className={classnames(
          styles.line,
          isOpen ? styles.line_middle_open : styles.line_middle,
        )}
      />
      <div
        className={classnames(
          styles.line,
          isOpen ? styles.line_bottom_open : styles.line_bottom,
        )}
      />
    </div>
  );
}

Hamburger.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
};

Hamburger.defaultProps = {
  isOpen: false,
};

Hamburger.displayName = "Hamburger";

export default Hamburger;
